module.exports = __webpack_public_path__ + "img/ruach_yes.f6a2a16d.png";